<!--
 * @Author: your name
 * @Date: 2022-03-08 13:42:03
 * @LastEditTime: 2023-05-16 15:40:37
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/changma202204/index.vue
-->
<template>
  <div class="landing">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
            <div class="section">
              <VodeoCon
                src="https://source.qunarzz.com/site/images/wns/20230523-pengyong-video1.mp4"
                poster="https://campaigns-static.volvocars.com.cn/image/images/xc60_xw3_v01.jpg"
              ></VodeoCon>
              <div class="img1">
                <img
                  src="https://source.qunarzz.com/site/images/wns/20230523-pengyong-build1.jpg"
                  alt=""
                />
              </div>
              <div class="arrow-d animate-bounce-down">
                <img
                  src="https://source.qunarzz.com/site/images/wns/20230523-pengyong-arrow-down.png"
                  alt=""
                />
              </div>
            </div>
        </div>
      <div class="swiper-slide">
        <div class="section">
          <div class="imgOther">
            <img
              src="https://source.qunarzz.com/site/images/wns/20230523-pengyong-car.png"
              alt=""
            />
          </div>
          <div class="arrow-d animate-bounce-down">
            <img
              src="https://source.qunarzz.com/site/images/wns/20230523-pengyong-arrow-down.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="swiper-slide">
        <div class="section">
          <div class="imgOther imgOther2">
            <img
              src="https://source.qunarzz.com/site/images/wns/20230523-pengyong-street.png"
              alt=""
            />
          </div>
          <div class="arrow-d animate-bounce-down">
            <img
              src="https://source.qunarzz.com/site/images/wns/20230523-pengyong-arrow-down.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="swiper-slide">
        <div class="section bg-black">
          <div class="imgOther">
            <img
              src="https://source.qunarzz.com/site/images/wns/20230523-pengyong-deer.png"
              alt=""
            />
          </div>
          <div class="arrow-d animate-bounce-down">
            <img
              src="https://source.qunarzz.com/site/images/wns/20230523-pengyong-arrow-down.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="swiper-slide">
        <div class="section" style="background-color: #000">
          <div class="imgOther ">
            <img
              src="https://source.qunarzz.com/site/images/wns/20230523-pengyong-road.png"
              alt=""
            />
          </div>
          <!-- <div class="arrow-d">
            <img
              src="https://source.qunarzz.com/site/images/wns/20230523-pengyong-arrow-down.png"
              alt=""
            />
          </div> -->
          <!-- <a
            class="viewMore"
            href="https://www.volvocars.com.cn/zh-cn/cars/xc60-hybrid/"
            >点击可查看更多</a
          > -->
        </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import VodeoCon from "./components/video.vue";
export default {
  components: {
    VodeoCon,
  },
  mounted(){
    // alert(window.innerWidth,document.querySelector(".section").offsetHeight)
    new Swiper(".swiper-container", {
        direction: 'vertical',
        // followFinger: true,
        // observer: true,
        // observeParents: true,
      });
  },
  data() {
    return {
      videoSrc: "",
      posterUrl: "",
    }
  },
};
</script>
<style lang='less' scoped='true'>
.landing {
  .section {
    width:100%;
    // overflow: hidden;
    position:absolute;
    left:0;
    top:50%;
    max-height: 740px;
    position: absolute;
    left: 0;
    top: 50%;
    height: 100vh;
    transform: translateY(-50%);
    .arrow-d {
      position: absolute;
      left: 50%;
      bottom: 100px;
      margin-left: -7px;
      z-index:100;
      img {
        width: 14px;
        height: 8px;
      }
    }
  }
}
.swiper-container{
  height:100vh;
}
.swiper-slide{
  display:flex;
  display:-webkit-flex;
  align-items:center;
  -webkit-align-items: center;
  background:#989ba1;
}
.img1 {
  height: 534px;
  overflow: hidden;
  img{
    height:534px;
  }
}
.imgOther {
  position:relative;
}
.imgOther2 {
  height: 738px;
  position:relative;
  overflow:hidden;
  img{
    position:absolute;
    left:-1px;
    top:-1px;
    width: calc(100vw + 2px);
    max-width:inherit;
  }
//   overflow: hidden;
}
.viewMore {
  position: absolute;
  left: 50%;
  bottom: 99px;
  transform: translateX(-50%);
  text-decoration: underline;
  color: #fff;
  z-index:10;
}

.animate-bounce-down {
  animation-name: example;
  animation-delay: 1s;
  animation-duration: 1.8s;
  animation-iteration-count: infinite;
}

@keyframes example {
  0% {
    transform: translate(0, 0);
    opacity: 1;
  }

  25% {
    opacity: 0.6;
  }

  50% {
    opacity: 0.1;
  }

  100% {
    transform: translate(0, 20px);
    opacity: .1;
  }
}

</style>
